const APIservice = () => ({
  /**
   * A global function to call FB-ES.
   * All content requests should use this service.
   *
   * @param {string} endpoint
   * @param {*} data
   */
  async get(endpoint, data) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const responseData = await response.json()
    return responseData
  },
  async getWithoutAnyHeaders(endpoint) {
    const response = await fetch(endpoint, {
      method: 'GET'
    })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const responseData = await response.json()
    return responseData
  },
  async getWithHeaders(endpoint, headers) {
    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const responseData = await response.json()
    return responseData
  },
  async postWithHeaders(endpoint, data, headers) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const responseData = await response.json()
    return responseData
  }
})

export default APIservice
